module.exports = __webpack_public_path__ + "img/banner_bg.179a3017.png";